import './loader.css';

export default function LoaderKitsProfile() {
    function randomNumber(min:number, max:number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const KitItems = () => {
        let content = [];
        for (let i = 0; i < randomNumber(2,10); i++) content.push(<div className="item-1 kit__item loader-1" key={'kitLoaderItem'+i}></div>)
        return (<>{content}</>);
    }
    const KitGroup = () => (
        <div className="kit">
            <div className="kit__group__header">
                <div className="kit__group__title loader-1"></div>
                <div className="kit__group__cooldown loader-1"></div>
            </div>
            <div className="kit__group__items">
                <KitItems />
            </div>
        </div>
    )
    const ChooseBtn = () => (
        <div className={`choose_server loader-1`}></div>
    )

    return (
        <div className='xbox__div-1 kitsLoading'>
            <div className="kits__chooseServer__list">
                <ChooseBtn />
                <ChooseBtn />
            </div>
            <div className="kits__chooseGroup">
                <ChooseBtn/>
                <ChooseBtn/>
                <ChooseBtn/>
                <ChooseBtn/>
            </div>
            <div className="kit__group">
                <KitGroup />
                <KitGroup />
                <KitGroup />
            </div>
        </div>
    )
}